export default __webpack_public_path__ + "static/media/avery.04df11c5.jpeg";